export const indexFieldName = (parentFieldName: string, fieldName: string): string =>
  `${parentFieldName}.${fieldName}`;
